import { isMobile } from '~/genericFunctions';

export const isButtonVisible = (ismobile) => {
  return (isMobile(ismobile))? false: true;
};
